<template>
  <div id="home-wrap">
    <div class="header">车家</div>
    <div class="container">
      <div class="slide_show">
        <img src="../assets/image/Homepage/chejia_1.png"/>
      </div>
      <div class="service_item_show ">
        <img src="../assets/image/Homepage/chejia_2.png"/>
      </div>
      <div class="data_entry_part">
        <div class="data_entry_info_show">
          <p>递交审批资料,专享优先服务</p>
          <p>可融购置税、保险，首付一成起</p>
        </div>
        <button @click="toLogin" class="data_entry_button">获取额度</button>
      </div>
      <div class="cars_show_part" v-show="true">
        <p class="caption">全品牌全车型均可办理</p>
        <ul class="cars_cells">
          <li v-for="item in carInfo">
            <div class="car" @click="toVehicleInformation(item.skuType)">
              <div class="car_img">
                <img :src="item.imgUrl"/>
              </div>
              <div class="car_info">
                <div class="car_name_part">
                  <div class="car_hot_show" v-show="item.carStaticInformationShowFlag">
                    <img :src="hotIcon">
                  </div>
                  <p>{{item.carName}}</p>
                </div>
                <div class="car_content_p" v-for="contentStr in item.content">{{contentStr}}</div>
                <div class="car_down-payment_part" v-show="item.carStaticInformationShowFlag">首付:<span
                  class="down-payment_num">{{item.downPayment}}</span></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="store_address_part">
        <p class="caption">门店地址</p>
        <ul class="address_cells">
          <li class="address_cell" v-for="item in storeAddressShowList">
            <div class="address_show">
              <div class="address_icon" v-show="item.addressStaticInformationShowFlag">
                <img :src="addressIcon"/>
              </div>
              <div class="address_content">
                <p class="address_text">{{item.addressDetailText}}</p>
                <div class="address_contact_info">
                  <div class="address_principal">城市经理:<span>{{item.addressPrincipal}}</span></div>
                  <div class="address_contact">电话:<a :href="'tel:' + item.addressContact">{{item.addressContact}}</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <div class="loading_part" @click="upAddressdDataNumShow" v-show="storeAddressLoadMoreFlag">
            <p>更多门店</p>
            <img src="../assets/image/Homepage/chejia_5.png"/>
          </div>
        </ul>
      </div>
      <div class="cases_show_part">
        <div class="caption"><p>最新提车</p></div>
        <div class="case_img">
          <img src="../assets/image/Homepage/chejia_case.png"/>
        </div>
        <mt-swipe :show-indicators="false" class="case_info">
          <mt-swipe-item class="case_info_in" v-for="(item,index) in casesInfo" v-bind:key="index">
            <div class="case_info_content">
              <div><p>最新提车</p></div>
              <div><p>{{item.name}}</p></div>
              <div><p>{{item.city}}</p></div>
              <div><p>{{item.mobile}}</p></div>
              <div><p>{{item.money}}万</p></div>
            </div>
          </mt-swipe-item>
        </mt-swipe>
        <div class="chejia_logo"><img src="../assets/image/Homepage/logo.png"/></div>
      </div>
      <div class="cooperation_part">
        <img src="../assets/image/Homepage/chejia_6.png"/>
      </div>
      <div class="qcode_part">
        <div><img src="../assets/image/Homepage/chejia_qcode.png"/></div>
        <div><img src="../assets/image/Homepage/chejia_dd_qcode.png"/></div>
      </div>
      <div class="serviceTel"><a href="tel:4008-211-510"><img src="../assets/image/Homepage/chejia_7.png"/></a></div>
    </div>
    <div class="footer"><img src="../assets/image/Homepage/chejia_8.png"/></div>
  </div>
</template>

<script>
  import addressIcon from '../assets/image/Homepage/chejia_storeAddress_icon.png'
  import hotIcon from '../assets/image/Homepage/chejia_hot.png'
  import ei5 from '../assets/image/Homepage/chejia_car_1.png'
  import ei6 from '../assets/image/Homepage/chejia_car_2.png'
  import ex5 from '../assets/image/Homepage/chejia_car_3.png'
  import common from '../utils/common'
  import wx from 'weixin-js-sdk';
  import Vue from 'vue'
  import {InfiniteScroll} from 'mint-ui';
  import {Indicator} from 'mint-ui';
  import qs from 'qs';


  Vue.use(InfiniteScroll);
  Vue.use(Indicator);
  Vue.use(wx);

  export default {
    name: "Homepage",
    data() {
      return {
        // loading: false,
        mobile: '',
        hotIcon: hotIcon,
        addressIcon: addressIcon,
        caseShowFlag: false,
        caseObj: null,
        temporaryArr: [],
        storeAddressLoadMoreFlag: true,
        storeAddressShowNum: 2,
        carInfo: [
          {
            imgUrl: ex5,
            carName: '威马EX5车家出行版',
            content: ['合规营运双证 极致驾乘体验'],
            downPayment: 13800,
            carStaticInformationShowFlag: true,
            skuType: '0'
          },
          {
            imgUrl: ei5,
            carName: '荣威 EI5 420KM 豪华版',
            content: ['电动车中的“金霸王”', '一键防夹电动天窗'],
            downPayment: 20670,
            carStaticInformationShowFlag: true,
            skuType: '1'
          },
          {
            imgUrl: ei6,
            carName: '荣威 EI6 智享版',
            content: ['插电混动互联网轿车', '百公里综合油耗1.5L'],
            downPayment: 21900,
            carStaticInformationShowFlag: true,
            skuType: '2'
          }
        ],
        storeAddress: [
          // {
          //   addressDetailText: '浙江省杭州市拱墅区杭行路666号万达商业中心3幢1单元705室',
          //   addressPrincipal: '常经理',
          //   addressContact: '186-0210-4134',
          //   addressStaticInformationShowFlag: true
          // },
          {
            addressDetailText: '江苏省常州市武进区星火南路益联汽贸市场西南门10-105号2楼',
            addressPrincipal: '胡经理',
            addressContact: '138-6118-7240',
            addressStaticInformationShowFlag: true
          },
          {
            addressDetailText: '广东省广州市越秀区东风东路836号东峻广场4座32楼',
            addressPrincipal: '王经理',
            addressContact: '136-7813-7482',
            addressStaticInformationShowFlag: true
          },
          {
            addressDetailText: '四川省成都市金牛区蜀西路48号西城国际B栋902室',
            addressPrincipal: '王经理',
            addressContact: '136-7813-7482',
            addressStaticInformationShowFlag: true
          },
          {
            addressDetailText: '江苏省无锡市梁溪区钟书路99号无锡国金中心25楼2551室',
            addressPrincipal: '沈经理',
            addressContact: '186-0146-9939',
            addressStaticInformationShowFlag: true
          },
          {
            addressDetailText: '湖北省武汉市汉阳区东风大道万达广场C6-1804室',
            addressPrincipal: '汪经理',
            addressContact: '180-6250-6363',
            addressStaticInformationShowFlag: true
          },
          {
            addressDetailText: '江苏省苏州市吴中区宝带东路399号中润中心2幢A座1505室',
            addressPrincipal: '沈经理',
            addressContact: '186-0146-9939',
            addressStaticInformationShowFlag: true
          }

        ],
        casesInfo: []
      }
    },
    computed: {
      storeAddressShowList: function () {
        const {storeAddressShowNum, storeAddress, temporaryArr} = this
        temporaryArr.length = 0
        for (let i = 0; i <= storeAddressShowNum; i++) {
          temporaryArr.push(storeAddress[i])
        }
        return temporaryArr;
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      this.$nextTick(function () {
        this.mobile = common.getUrlKey('mobile')
        const router = this.$router;
        let data = {"mobile": this.mobile}
        this.$axios.post('/marketing/record', qs.stringify(data)).then(function (res) {
          return
        }).catch(function (error) {
          return
        })
        const that = this
        that.$axios.post('/marketing/lastestinfo', {})
          .then(function (res) {
            that.casesInfo = res.data.data
          }).catch(function (error) {
          return
        })

        that.$axios.get('/mp/ticket/wx139a9bf36bf1ee1b', {})
          .then(function (res) {
            wx.config({
              debug: false,
              appId: res.data.data.appId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              signature: res.data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
          }).catch(function (error) {
          return
        })
        wx.ready(function () {
          const title = '车家';
          const desc = '全品牌全车型均可办理，家用与网约车兼顾，即开即赚！';
          const link = "http://mkt.chejia.net.cn";
          const imgUrl = 'http://mkt.chejia.net.cn/share/share.png';
          //分享到朋友圈
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
          //分享给朋友
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
          //分享到QQ
          wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
          //分享到腾讯微博
          wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
          //分享到QQ空间
          wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
        });
      })
    },
    methods: {
      toLogin() {
        const router = this.$router;
        if (sessionStorage.getItem("mobilePhone")) {
          router.push({
            path: '/photo',
            name: "Photo",
            params: {}
          })
        } else {
          router.push({
            path: '/login',
            name: "Login"
          })
        }
      },
      upAddressdDataNumShow() {
        if (this.storeAddressShowNum == 2) {
          this.storeAddressShowNum = 5
          this.storeAddressLoadMoreFlag = false
        }
      },
      toVehicleInformation(type) {
        const router = this.$router;
        sessionStorage.setItem("type", type)
        router.push({
          path: '/vehicleInformation',
          name: "VehicleInformation",
          params: {}
        })
      }
    }
  }
</script>

<style scoped>
  /*#home-wrap div{*/
  /*background-color: #fff;*/
  /*}*/
  #home-wrap p, #home-wrap button {
    margin: 0;
    padding: 0;
  }

  #home-wrap {
    width: 100vw;
    background-color: #fff;
  }

  #home-wrap > .header {
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }

  #home-wrap > .container {
    width: 100%;
  }

  #home-wrap > .container > .slide_show {
    margin: 0 auto;
    width: 7.1rem;
    font-size: 0;
  }

  #home-wrap > .container > .slide_show > img {
    width: 100%;
  }

  #home-wrap > .container > .service_item_show {
    margin: 0 auto;
    padding-top: 0.42rem;
    width: 6.7rem;
    font-size: 0;
  }

  #home-wrap > .container > .service_item_show > img {
    width: 100%;
  }

  .data_entry_part {
    margin: 0 auto;
    margin-top: 0.4rem;
    width: 7.1rem;
    height: 1.39rem;
    background-image: linear-gradient(90deg,
    #02fa88 0%,
    #0380f9 100%),
    linear-gradient(
      #2694ff,
      #2694ff);
    background-blend-mode: normal,
    normal;
    border-radius: 12px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .data_entry_info_show {
    margin-left: 0.31rem;
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .data_entry_info_show > p {
    background-color: rgba(255, 255, 255, 0) !important;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .data_entry_info_show p:first-child {
    font-size: 0.32rem;
    line-height: 0.52rem;

  }

  .data_entry_info_show p:last-child {
    font-size: 0.24rem;
    line-height: 0.44rem;
  }

  .data_entry_part > button {
    margin-right: 0.58rem !important;
    width: 1.9rem;
    height: 0.58rem;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.58rem;
    letter-spacing: 0px;
    color: #1f1f1f;
    background-color: #fff;
    border-radius: 12px;
    border-width: 0;
    outline: none;
  }

  .cars_show_part {
    bordder: 1px solid black;
    padding-top: 0.55rem;
    margin: 0 auto;
    width: 7.1rem;
  }

  .cars_show_part > .caption {
    width: 100%;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    background: linear-gradient(90deg,
    #42d58f 0%,
    #268fff 100%),
    linear-gradient(
      #2490fd,
      #2490fd); /* 背景色渐变 */
    -webkit-background-clip: text; /* 规定背景的划分区域 */
    -webkit-text-fill-color: transparent; /* 防止字体颜色覆盖 */
    text-align: center;
  }

  .cars_show_part > .cars_cells {
    /*margin: 0;*/
    padding: 0;
    margin: 0;
    margin-top: 0.35rem;
    width: 100%;
    list-style: none;
  }

  .cars_show_part > .cars_cells > li {
    border-top: 0.04rem solid #f4f4f4;
  }

  .cars_show_part > .cars_cells > li > .car {
    padding-top: 0.4rem;
    display: flex;
    flex-flow: row nowrap;
  }

  li > .car > .car_img {
    margin-left: 0.33rem;
    margin-right: 0.41rem;
    width: 2.74rem;
    height: 1.47rem;
    font-size: 0;
  }

  li > .car > .car_img > img {
    width: 100%;
  }

  li .car_info {
    min-height: 1.47rem;
    padding-bottom: 0.45rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
  }

  li .car_name_part {
    display: flex;
    flex-flow: row nowrap;
  }

  li .car_name_part > .car_hot_show {
    width: 0.27rem;
    height: 0.31rem;
    font-size: 0;
  }

  li .car_name_part > .car_hot_show > img {
    width: 100%;
  }

  li .car_name_part > p {
    margin-left: 0.08rem !important;
    font-size: 0.27rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #000012;
  }

  li .car_content_p {
    margin-top: 0.08rem;
    font-size: 0.22rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.3rem;
    letter-spacing: 0px;
    color: #000012;
  }

  .car_info > .car_content_p:nth-child(2) {
    margin-top: 0.2rem;
  }

  li .car_down-payment_part {
    margin-top: 0.2rem;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.24rem;
    letter-spacing: 0px;
    color: #000012;
  }

  li .car_down-payment_part > .down-payment_num {
    margin-left: 0.1rem;
  }

  .store_address_part {
    margin-top: 0.2rem;
    margin: 0 auto;
    padding-top: 0.35rem;
    width: 7.1rem;
    background-image: url("../assets/image/Homepage/chejia_4.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .store_address_part > .caption {
    width: 100%;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    background: linear-gradient(90deg,
    #42d58f 0%,
    #268fff 100%),
    linear-gradient(
      #2490fd,
      #2490fd); /* 背景色渐变 */
    -webkit-background-clip: text; /* 规定背景的划分区域 */
    -webkit-text-fill-color: transparent; /* 防止字体颜色覆盖 */
    text-align: center;
  }

  .address_cells {
    margin: 0;
    padding: 0;
    margin-top: 0.63rem;
    padding-bottom: 0.15rem;
    list-style: none;
  }

  .address_cell {
    margin-left: 0.39rem;
    padding-top: 0.29rem;
    padding-bottom: 0.29rem;
    width: 6.51rem;
    border-bottom: 0.04rem solid #f4f4f4;
  }

  .address_cells > .address_cell:first-child {
    padding-top: 0;
  }

  .address_show {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .address_show > .address_icon {
    width: 0.36rem;
    height: 0.43rem;
    font-size: 0;
  }

  .address_show > .address_icon > img {
    width: 100%;
  }

  .address_show > .address_content {
    margin-left: 0.32rem;
  }

  .address_cell .address_contact_info {
    margin-top: 0.12rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .address_cell .address_text {
    max-width: 5.7rem;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #000012;
  }

  .address_cell .address_contact {
    margin-left: 0.36rem;
  }

  .address_cell .address_contact_info div {
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #000012;
  }

  .address_cell .address_contact_info div > span {
    margin-left: 0.06rem;
  }

  .address_cell .address_contact_info div > a {
    margin-left: 0.06rem;
    text-decoration: none;
    color: #222;
  }

  .loading_part {
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
    margin: 0 auto;
    margin-top: 0.15rem;
    width: 40%;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .loading_part > p {
    font-size: 0.22rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #000012;
  }

  .loading_part > img {
    margin-left: 0.1rem;
    width: 0.20rem;
  }

  .cases_show_part {
    position: relative;
    margin: 0 auto;
    margin-top: 0.68rem;
    width: 6.66rem;
    height: 3.25rem;
    border-style: solid;
    border-width: 2px;
    border-image-source: linear-gradient(70deg,
    rgba(66, 218, 148, 0.3) 0%,
    rgba(3, 128, 249, 0.3) 100%);
    border-image-slice: 1;
  }

  .cases_show_part .caption {
    position: absolute;
    top: -0.16rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 2.50rem;
    background-color: #fff;
  }

  .cases_show_part .caption p {
    font-size: 0.32rem;
    line-height: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    background: linear-gradient(90deg,
    #42d58f 0%,
    #268fff 100%),
    linear-gradient(
      #2490fd,
      #2490fd); /* 背景色渐变 */
    -webkit-background-clip: text; /* 规定背景的划分区域 */
    -webkit-text-fill-color: transparent; /* 防止字体颜色覆盖 */
    text-align: center;
    background-color: #fff;
  }

  .case_img {
    margin: 0 auto;
    margin-top: 0.4rem;
    width: 6.14rem;
    height: 1.72rem;
    font-size: 0;
  }

  .case_img > img {
    width: 100%;
  }

  .case_info {
    margin: 0 auto;
    margin-top: 0.30rem;
    max-width: 5.45rem;
    min-width: 4.36rem;
    height: 0.45rem !important;
    background-image: linear-gradient(90deg,
    rgba(2, 250, 136, .12) 0%,
    rgba(3, 128, 249, .12) 100%),
    linear-gradient(
      #ebebeb,
      #ebebeb);
    background-blend-mode: normal,
    normal;
    border-radius: 0.22rem;
    overflow: hidden;
  }

  .case_info > .mint-swipe-items-wrap {
    width: 100%;
    height: 0.45rem;
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .case_info_in {
    width: 100%;
    height: 0.45rem;
  }

  .case_info_content {
    width: 100%;
    height: 0.45rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .case_info_content > div {
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .case_info_content > div:first-child {
    margin-left: 0.19rem;
  }

  .case_info_content > div:nth-child(2) {
    margin-left: 0.10rem;
  }

  .case_info_content > div:nth-child(3) {
    margin-left: 0.05rem;
  }

  .case_info_content > div:last-child {
    margin-right: 0.15rem;
  }

  .case_info_content > div > p {
    font-size: 0.20rem;
    font-weight: bold;
    font-stretch: normal;
    line-height: 0.2rem;
    color: #222;
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .cases_show_part > .chejia_logo {
    position: absolute;
    bottom: -0.11rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0 0.2rem;
    width: 0.57rem;
    font-size: 0;
    background-color: #fff;
  }

  .cases_show_part > .chejia_logo > img {
    width: 100%;
  }

  .cooperation_part {
    margin: 0 auto;
    margin-top: 0.99rem;
    width: 5.64rem;
    height: 1.61rem;
  }

  .cooperation_part > img {
    width: 100%;
  }

  .qcode_part {
    margin: 0 auto;
    margin-top: 1.28rem;
    width: 4.32rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .qcode_part div {
    height: 2.31rem;
    font-size: 0;
  }

  .qcode_part div:first-child {
    width: 1.71rem;
  }

  .qcode_part div:last-child {
    margin-left: 0.63rem;
    width: 1.98rem;
  }

  .qcode_part > div > img {
    width: 100%;
  }

  .serviceTel {
    margin-top: 0.43rem;
    width: 100%;
    height: 0.26rem;
  }

  .serviceTel > a {
    margin: 0 auto;
    display: block;
    padding-right: 0.36rem;
    width: 2.07rem;
    height: 0.26rem;
    text-decoration: none;
    font-size: 0;

  }

  .serviceTel > a > img {
    width: 100%;
  }

  #home-wrap > .footer {
    margin-top: 0.74rem;
    width: 7.5rem;
    height: 0.54rem;
    font-size: 0;
  }

  #home-wrap > .footer > img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue